import axios from 'axios';

// export const baseUrl  = 'https://j2hcgwbo30.execute-api.us-east-1.amazonaws.com/aurenity_dev/'

export const baseUrl  = 'https://rviwokqbh0.execute-api.us-east-1.amazonaws.com/aurenity_prd/'


const axiosInstance = axios.create({
  baseURL: baseUrl, // Replace with your API base URL
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Add headers here
    // config.headers['Content-Type'] = 'application/json';
    // config.headers['Access-Control-Allow-Origin'] = '*'; // Adjust as needed
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    // Pass through successful responses
    return response;
  },
  (error) => {
    // Check if the error is due to token expiration
    if (error.response && error.response.status === 401) {
      // Clear any stored tokens (if applicable)
      localStorage.removeItem("token");
      // Redirect to login page
      window.location.href = "/"; 
    }
 
    return Promise.reject(error);
  }
);

export default axiosInstance;